import { useState } from 'react';
import { Typography, Input, Button, enqueueSnackbar } from '../../../design-system';
import {
  AuthHeaderBase,
  AuthHeaderSubTitle,
  AuthFormBase,
  AuthFooterBase,
  AuthFooterLink,
  AuthFooterLanguage,
} from '../AuthComponents';
import { useForgotPasswordMutation, useIsSmallScreen } from '../../../hooks';
import { INPUT_ERRORS, MESSAGES } from '../../../const';
import { i18n } from '../../../i18n';

export const ForgotPasswordHeader = () => {
  return (
    <AuthHeaderBase>
      <Typography variant={'h4'} align={'center'} weight={'bold'}>
        {i18n.t('pages.forgotPassword.title')}
      </Typography>
      <AuthHeaderSubTitle>
        <Typography variant={'textM'} color={'--gray-80'} align={'center'}>
          {i18n.t('pages.forgotPassword.subTitle')}
        </Typography>
      </AuthHeaderSubTitle>
    </AuthHeaderBase>
  );
};

export const ForgotPasswordForm = () => {
  const { mutate, isLoading } = useForgotPasswordMutation();
  const isSmallScreen = useIsSmallScreen();

  const [email, setEmail] = useState('');
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);

  const validators = {
    email: !email ? INPUT_ERRORS.REQUIRED.EMAIL : '',
  };

  const handleSubmitClick = async () => {
    if (!Object.values(validators).every((isError) => !isError)) {
      setIsSubmitClicked(true);
      return;
    }

    await mutate(
      { email },
      {
        onSuccess: () => {
          enqueueSnackbar(MESSAGES.AUTH.SUCCESS.RESET_PASSWORD_INSTRUCTIONS, 'success');
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.AUTH.ERROR.NOT_RESET_PASSWORD, 'error');
        },
        onSettled: () => {
          setIsSubmitClicked(false);
        },
      },
    );
  };

  return (
    <AuthFormBase>
      <Input
        defaultValue={email}
        onChange={(e) => setEmail(e.target.value)}
        label={i18n.t('label.email')}
        placeholder={i18n.t('placeholder.email')}
        type={'email'}
        data-size={'large'}
        error={isSubmitClicked && validators.email}
        helperText={isSubmitClicked && validators.email}
      />
      <Button
        data-color={'primary'}
        size={'large'}
        onClick={handleSubmitClick}
        disabled={isLoading}
      >
        {i18n.t('button.sendResetLink')}
      </Button>
      {isSmallScreen && <AuthFooterLanguage />}
    </AuthFormBase>
  );
};

export const ForgotPasswordFooter = () => {
  return (
    <AuthFooterBase>
      <span />
      <Typography variant={'textS'} color={'--primary-100'}>
        <AuthFooterLink to={'/signin'} withunderline>
          {i18n.t('button.backToSignIn')}
        </AuthFooterLink>
      </Typography>
    </AuthFooterBase>
  );
};
